import type { TourConfig } from './types';

export const leadFormsTour: TourConfig = {
  id: 'lead-forms-page',
  name: 'Lead Forms Tour',
  description: 'Learn how to create and manage lead capture forms',
  requiredPath: '/dashboard/lead-forms',
  steps: [
    {
      element: '[data-tour="lead-forms-header"]',
      popover: {
        title: 'Lead Capture Forms',
        description:
          'Create embeddable lead capture forms for your website to automatically collect new leads.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="lead-forms-create-button"]',
      popover: {
        title: 'Create Form',
        description:
          'Click here to create a new lead capture form with custom fields.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="lead-forms-search"]',
      popover: {
        title: 'Search Forms',
        description: 'Quickly find forms by searching their name.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="lead-forms-status-filter"]',
      popover: {
        title: 'Filter by Status',
        description:
          'Filter forms by their status: Draft, Active, or Archived.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="lead-forms-table"]',
      popover: {
        title: 'Forms Table',
        description:
          'View all your forms here with submission counts. Use the actions menu to edit, view submissions, or get embed codes.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
